import { Router } from '@angular/router';
import { Hub } from 'aws-amplify/utils';
import { firstValueFrom } from 'rxjs';

import { LocalStorageKey } from '@shared/constants/localStorageKey';
import { ApiService } from '@shared/services/api.service';
import { AppInitService } from '@shared/services/app-init.service';
import { LaunchDarklyService } from '@shared/services/launch-darkly.service';
import { AuthService } from '@shared/store/auth/auth.service';

export function appServiceInit(api: ApiService, service: AppInitService) {
  return async (): Promise<void> => {
    const x = await firstValueFrom(api.getAppProperties());

    service.APP_VERSION = x.version || '';
    service.SAML_PROVIDERS = x.samlProviders || [];
  };
}

export function initUser(auth: AuthService, router: Router) {
  return async (): Promise<void> => {
    const isAuthenticated = await auth.isAuthenticated();

    if (isAuthenticated) {
      await auth.setUserAttributes({ showUserLogInError: false });
    } else {
      // aws is not initialized in sso case. So in here we are waiting for the aws auth to give us an event
      const isSubmit = localStorage.getItem(LocalStorageKey.LOGIN_SSO_SUBMIT);

      if (
        (window.location.pathname === '/login' || window.location.pathname === '/') &&
        isSubmit === 'true'
      ) {
        localStorage.setItem(LocalStorageKey.LOGIN_SSO_SUBMIT, 'false');
        await new Promise((res) => {
          // eslint-disable-next-line @typescript-eslint/no-misused-promises
          Hub.listen('auth', async ({ payload }) => {
            switch (payload.event) {
              case 'signInWithRedirect': {
                await auth.setUserAttributes({ showUserLogInError: false });
                const lastURL = localStorage.getItem(LocalStorageKey.LOGIN_LAST_URL);

                await router.navigate([`${lastURL || '/'}`]);
                res(true);
                break;
              }

              case 'signInWithRedirect_failure':
                res(true);
                break;
              default:
                break;
            }
          });
        });
      }
    }
  };
}

export function launchDarklyInit(service: LaunchDarklyService) {
  return (): Promise<void> => {
    return service.initLaunchDarkly();
  };
}
